"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThcCbdUnit = exports.WeightUnit = void 0;
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["G"] = "g";
})(WeightUnit || (exports.WeightUnit = WeightUnit = {}));
var ThcCbdUnit;
(function (ThcCbdUnit) {
    ThcCbdUnit["PERCENT"] = "%";
    ThcCbdUnit["MG"] = "mg";
    ThcCbdUnit["ML"] = "ml";
    ThcCbdUnit["MG_G"] = "mg/g";
    ThcCbdUnit["MG_ML"] = "mg/mL";
    ThcCbdUnit["MG_UNIT"] = "mg/unit";
})(ThcCbdUnit || (exports.ThcCbdUnit = ThcCbdUnit = {}));
//# sourceMappingURL=units.js.map